import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

const IndustryCard = ({
  image,
  imagePosition,
  category,
  title,
  description,
  capabilities,
  ctaLabel,
}) => {
  return (
    <Link
      to="/contactus"
      aria-label={ctaLabel}
      className="group relative block aspect-[4/3] overflow-hidden rounded-3xl border border-slate-200/60 shadow-sm transition-all duration-300 hover:shadow-2xl hover:border-white/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
    >
      {/* Background image */}
      <img
        src={image}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.06] motion-reduce:group-hover:scale-100"
        style={{ objectPosition: imagePosition }}
        loading="lazy"
        decoding="async"
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/50 to-slate-950/20 transition-colors duration-300 group-hover:from-slate-950/95 group-hover:via-slate-950/70" />

      {/* Arrow button */}
      <span
        className="absolute right-5 top-5 z-10 flex h-12 w-12 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white shadow-[0_0_24px_-8px_rgba(0,0,0,0.4)] backdrop-blur-sm transition duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:bg-white/20 group-hover:shadow-blue-500/20"
        aria-hidden="true"
      >
        <FiArrowUpRight className="h-5 w-5" strokeWidth={2} />
      </span>

      {/* Content */}
      <div className="absolute inset-x-0 bottom-0 z-10 p-6 md:p-7">
        <span className="inline-block rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white/95 backdrop-blur-sm">
          {category}
        </span>

        <h3 className="mt-3 font-raleway text-xl font-bold text-white md:text-2xl">
          {title}
        </h3>

        <p className="mt-2 font-openSans text-sm leading-relaxed text-white/85 md:text-base">
          {description}
        </p>

        {/* Capability list — desktop hover only */}
        <ul className="hidden lg:mt-4 lg:space-y-2 lg:translate-y-3 lg:opacity-0 lg:transition-all lg:duration-300 lg:group-hover:translate-y-0 lg:group-hover:opacity-100">
          {capabilities.map((item) => (
            <li
              key={item}
              className="flex items-center gap-2 font-openSans text-sm text-slate-100"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-blue-400" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </Link>
  );
};

export default IndustryCard;
